export default {
  init() {


		jQuery('.icon-share.print a').click(function(){
  		window.history.pushState('obj', 'newtitle', '/compare/?pdf');
  		location.reload();
    });

		$('.car_compare_2 .remove_car_compare').click(function(){

			$.ajax({
		    type: "GET",
		    async: true,
		    url: window.location.pathname,
		    data: {
		    	remove_car_2: 'remove_car_2',
		    },
		    success: function (msg)
        { window.location.href = '/cars' },
        error: function (err)
        { }
		  });

		  localStorage.removeItem("image_compare_2");
      localStorage.removeItem("title_compare_2");
      localStorage.removeItem("post_id_2");

		});

		$('.car_compare_1 .remove_car_compare').click(function(){

			$.ajax({
		    type: "GET",
		    async: true,
		    url: window.location.pathname,
		    data: {
		    	remove_car_1: 'remove_car_1',
		    },
		    success: function (msg)
        { window.location.href = '/cars' },
        error: function (err)
        { }
		  });

		  localStorage.removeItem("image_compare_1");
      localStorage.removeItem("title_compare_1");
      localStorage.removeItem("post_id_1");

		});


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/compare.js